import axios from "axios";
import { CommonTexts as Texts } from "../helpers/LayoutTexts";
import { DiplomaSearchCriteria } from "../models/DiplomaSearchCriteria";
import { Diploma } from "../models/Diploma";

export async function getStateDiplomaSearchOptions() {
    return new Promise<any>((resolve, reject) => {
        axios
        .get(Texts.apiBaseUrl + "state-diplomas/diploma-search-options", {           
            params: {                
                languageCode: "SIN"
            }
        })
        .then((response) => {                
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function getStateDiplomas(model: DiplomaSearchCriteria) {
    return new Promise<any>((resolve, reject) => {
        axios
        .get(Texts.apiBaseUrl + "state-diplomas/diploma-search-results-by-admin", {            
            params: model
        })
        .then((response) => {                
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function getStateDiploma(diplomaId: number, adminId: number, token: string) {
    return new Promise<any>((resolve, reject) => {
        axios
        .get(Texts.apiBaseUrl + "state-diplomas/diploma-by-admin", {   
            headers: {
                'Authorization' : `Bearer ${token}`
            },         
            params: {                
                diplomaId: diplomaId,
                adminId: adminId
            }
        })
        .then((response) => {                
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function postStateDiplomaEdit(diploma: Diploma, adminId: number, token: string) {    
    return new Promise<any>((resolve, reject) => {
        axios 
        .post(Texts.apiBaseUrl + "state-diplomas/diploma-edit-by-admin", diploma, {
            headers: {
              'Content-Type': 'application/json',              
              'Authorization' : `Bearer ${token}`
            },
            params: {
                adminId: adminId
            }
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    })
}

export async function getPrivateDiplomaSearchOptions() {
    return new Promise<any>((resolve, reject) => {
        axios
        .get(Texts.apiBaseUrl + "private-diplomas/diploma-search-options", {           
            params: {                
                languageCode: "SIN"
            }
        })
        .then((response) => {                
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function getPrivateDiplomas(model: DiplomaSearchCriteria) {
    return new Promise<any>((resolve, reject) => {
        axios
        .get(Texts.apiBaseUrl + "private-diplomas/diploma-search-results-by-admin", {            
            params: model
        })
        .then((response) => {                
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function getPrivateDiploma(diplomaId: number, adminId: number, token: string) {
    return new Promise<any>((resolve, reject) => {
        axios
        .get(Texts.apiBaseUrl + "private-diplomas/diploma-by-admin", {   
            headers: {
                'Authorization' : `Bearer ${token}`
            },         
            params: {                
                diplomaId: diplomaId,
                adminId: adminId
            }
        })
        .then((response) => {                
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function postPrivateDiplomaEdit(diploma: Diploma, adminId: number, token: string) {    
    return new Promise<any>((resolve, reject) => {
        axios 
        .post(Texts.apiBaseUrl + "private-diplomas/diploma-edit-by-admin", diploma, {
            headers: {
              'Content-Type': 'application/json',              
              'Authorization' : `Bearer ${token}`
            },
            params: {
                adminId: adminId
            }
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    })
}
